module.exports = __webpack_public_path__ + "assets/graficos.9d094adc32efc989d426d4fed5cd4a75.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/graficos.png
// module id = 883
// module chunks = 0